import React, { useEffect, useState, useRef } from "react"
import MetaTags from "react-meta-tags"
import { withRouter, Link } from "react-router-dom"
import { get } from "lodash"
import moment from "moment"

import { Button, Card, CardBody, Col, Container, Row, Label } from "reactstrap"

//redux
import { useSelector, useDispatch } from "react-redux"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import { getAccessExpiration } from "helpers/repository"
import {sitename} from "../../../constants/constants";

const AccessExpiration = props => {
  const dispatch = useDispatch()
  const [accessExpiration, setAccessExpiration] = useState(null)
  useEffect(() => {
    getAccessExpiration().then(res => {
      const defDate = new Date(res?.data?.data?.access_expiration?.expires_at)
      const format = "YYYY-MM-DD HH:mm:ss"
      let isValid = moment(defDate, format).isValid()
      isValid ? setAccessExpiration(defDate) : setAccessExpiration(null)
    })
  }, [])

  //pagination customization

  const handleClick = () => {
    props.history.push(`set-access-expiration`)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Settings" breadcrumbItem="Access Expiration" />
          <Row>
            <Col lg={6}>
              <Card>
                <CardBody>
                  <div className="row mb-4">
                    <Col xs={6} sm={4} md={4} lg={6}>
                      <Label className="col-form-label">
                        Access Expiration
                      </Label>
                    </Col>
                    <Col xs={6} sm={8} md={8} lg={6}>
                      <p className="text-muted fw-medium col-form-label">
                        {`${
                          ![undefined, null, ""].includes(accessExpiration)
                            ? accessExpiration.toLocaleString('en-GB')
                            : "No Expiry date set"
                        }`}
                      </p>
                    </Col>
                  </div>

                  <div className="d-flex flex-wrap gap-2">
                    <Button
                      type="button"
                      color="primary"
                      className=""
                      onClick={handleClick}
                    >
                      Set Access Expiration
                    </Button>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(AccessExpiration)
